import { useThemeStore } from "@stores/theme.store";
import { Select } from "antd";
import moment from "moment-timezone";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { linkPage } from "@utils/router";
import { useQuery } from "@tanstack/react-query";
import { SchoolService } from "@services/school.service";
import { FcFinePrint } from "react-icons/fc";
import { Spiner } from "@components/loaders/spiner";
import { PermitService } from "@services/permit.service";
import { Permit } from "@services/dtos/permit.dto";
moment.locale("id");

export const PermitDataPage = () => {
  const navigate = useNavigate();
  const { setHeader, setAppBar } = useThemeStore((state) => state);
  const [limit, setLimit] = useState<string>("10");

  const { data: dataNis } = useQuery({
    queryKey: [SchoolService.queries.GET_SCHOOL_STUDENT_BIO],
    queryFn: SchoolService.studentBio,
  });
  const nis = dataNis?.data?.nis ?? "";

  const {
    data,
    isPending: isPendingPermitData,
    refetch: refetchPermitData,
  } = useQuery({
    queryKey: [PermitService.queries.GET_PERMIT_DATA, nis, limit],
    queryFn: () => PermitService.data({ nis, limit }),
  });

  const onOpenDetail = (data: Permit) => {
    navigate(linkPage.PERMIT_DETAIL_PAGE, { state: data });
  };

  useEffect(() => {
    setAppBar({ title: "Data Perizinan", show: true, leading: "back" });
    setHeader({
      buttonBack: true,
      filter: false,
      title: "Data Perizinan",
    });
  }, [setHeader, setAppBar]);

  return (
    <>
      <div className="tw-px-4 tw-pb-20">
        <>
          <div className="tw-bg-other-100 tw-rounded-lg card-body">
            <div className="tw-text-xs tw-mb-1">Filter Data</div>
            <Select
              className="tw-border-other-0 tw-text-base"
              placeholder="Pilih Jumlah Ditampilkan"
              defaultValue={limit}
              style={{ width: "100%" }}
              allowClear
              onChange={(e) => setLimit(e)}
              options={[
                { value: "10", label: "10" },
                { value: "25", label: "25" },
                { value: "50", label: "50" },
                { value: "100", label: "100" },
              ]}
            ></Select>
            <p className="tw-mt-3 tw-text-sm">
              Data yang ditampilkan {limit} data terakhir
            </p>
          </div>

          <div className="tw-bg-other-100 tw-rounded-lg card-body tw-mt-3">
            {isPendingPermitData ? (
              <div className="tw-text-center">
                <Spiner />
              </div>
            ) : data?.data != null && data.data.length > 0 ? (
              <>
                {data.data.map((item, idx) => (
                  <div
                    key={idx}
                    className="tw-border-solid tw-border-x-0 tw-border-y-1 tw-border-y-other-200 tw-py-1 tw-mb-0.5"
                    onClick={() => onOpenDetail(item)}
                  >
                    <div className="tw-px-2 tw-flex tw-justify-between tw-items-center tw-font-semibold">
                      <div className="tw-text-xs tw-font-medium tw-text-other-600">
                        {item.acc === "Y"
                          ? "Diizinkan"
                          : item.acc === "N"
                          ? "Tidak Diizinkan"
                          : "Sedang Dikonfirmasi"}
                      </div>
                      <div className="tw-text-xs tw-font-medium tw-text-other-600">
                        Penjemput
                      </div>
                    </div>
                    <div className="tw-px-2 tw-flex tw-justify-between tw-items-center tw-font-semibold">
                      <div className="tw-text-sm">
                        {moment(item.datePermit ?? Date.now()).format(
                          "DD MMMM YYYY"
                        )}
                      </div>
                      <div className="tw-w-1/3 tw-text-end">
                        <div className="tw-text-sm">{item.pickup}</div>
                      </div>
                    </div>
                  </div>
                ))}
              </>
            ) : (
              <div className="tw-p-8 tw-text-center">
                <FcFinePrint size={50} />
                <div>Data tidak ditemukan</div>
              </div>
            )}
          </div>
        </>
      </div>
    </>
  );
};
